import {BenutzerModels} from './benutzer-models';
import jsPDF from 'jspdf';
import {DokumentModels} from './dokument-models';
import {GlobalModels} from './global-models';

export namespace ServiceAppModels {

    export interface SA_Config {
        // Navi => Stammdaten => ServiceApp
        spesenartMaterialeinkauf: number;
        kostenstelleMaterialeinkauf: number;
        checklisteUebermitteln: string;
        serviceIDGenerieren: boolean;
        werkstofflistenArtikel_uebermitteln: boolean;
        standardObjekt: string;
        // Navi => Stammdaten => ServiceApp => Einstellungen
        speseneintrag: boolean;
        kulanz: boolean;
        deleteDataAfterDays: number;
        preiseInRapportAnzeigen: boolean;
        waehrungInRapportAnzeigen: boolean;
        checklisteAusfuellen: false;
        kurzzeichenStunden: string;
        zeitenRundung: string;
        kleinmaterialArbeitInProzent: number;
        mwStSatz: number;
        standardKostenstelle: number;
        arbeitsortAnzeigen: boolean;
        dashboardIntervall: number;
        zeitenNichtAnZeitkontrolleSenden: boolean;
        spesenInRapportAnzeigen: boolean;
        fotosTyp9AnSASenden: boolean;
        zeiterfObjektAuswahlViaEingabe: boolean;
        verschiebungVonTerminenErlauben: boolean;
        syncInPast: number;
        syncInFuture: number;
        notClosedOrder: boolean;
    }

    export interface SynchronizationPeriod {
        syncInPast: number;
        syncInFuture: number;
        notClosedOrder: boolean;
    }

    export const DEFAULT_SYNC_PERIOD: SynchronizationPeriod = {
        syncInPast: 14,
        syncInFuture: 14,
        notClosedOrder: false
    };

    export interface Stammdaten {
        sA_UserRights: SA_UserRights;
        sA_CostCenter: SA_CostCenter[];
        sA_Expenses: SA_Expenses[];
        sA_Employees: SA_Employees[];
        sA_AdressTypes: SA_AdressTypes[];
        sA_CostCenterRates: SA_CostCenterRates[];
        sA_EmployeeRates: SA_EmployeeRates[];
    }

    export interface SA_UserRights {
        allowEditEinsatzplan: boolean;
    }

    export interface SA_CostCenter {
        costCenterID: number;
        description: string;
        obligatoryWorkplace: boolean;
        travelTime: boolean;
        overheadRate1: number;
        considerPayroll: boolean;
    }

    export interface SA_Expenses {
        expenseID: number;
        description: string;
        amountOne: number;
        rate: number;
        mandator: string;
        unit: string;
        notChargeable: boolean;
    }

    export interface SA_Employees {
        employeeID: number;
        lastName: string;
        firstName: string;
        team: string;
        sA_ShowExpense?: number;
        sA_ShowGoodwill?: number;
        sA_InsertTimesAuto?: number;
        sA_DeleteDataAfter?: number;
        sA_ShowPrices?: number;
        sA_EditChecklist?: number;
        sA_HoursText: string;
        sA_RoundTimes?: number;
        sA_PercentageIncidentals?: number;
        sA_PercentageVAT?: number;
        sA_DefaultCostCenter?: number;
        sA_ShowWorkplace?: number;
        sA_DashboardIntervall?: number;
        sA_Dontsendtimestotimecontrol?: number;
        sA_ShowExpenseInRapport?: number;
    }

    export interface SA_AdressTypes {
        addressTypeNumber: number;
        description: string;
    }

    export interface SA_CostCenterRates {
        fK_CostCenterID: number;
        validFrom: Date;
        validTo: Date;
        overheadRate1: number;
    }

    export interface SA_EmployeeRates {
        fK_EmployeeID: number;
        validFrom: Date;
        validTo: Date;
        overheadRate1: number;
        functionRate: number;
    }

    export interface Produkt {
        productNo: string;
        mandator: string;
        treeGroup: string;
        searchKey: string;
        shortText: string;
        stockUnit: string;
        salePrice?: number;
        length1?: number;
        width1?: number;
        thickness?: number;
        weightPerUnit?: number;
        productCode?: number;
    }

    export interface SA_ObjektKategorie {
        mandator: string;
        id: number;
        description: string;
        color: string;
        hexColor: string;
        active: number;
        sortOrder?: number;
    }

    export interface SA_Objekt {
        objectNumber: string;
        objectID: string;
        serviceID: string;
        fK_EmployeeID: string;
        team: string;
        absence: string;
        mandator: string;
        objDescription: string;
        note4: string;
        manufacturingDescription: string;
        memo: string;
        dateOfDelivery: string;
        dateOfDeliveryOK?: number;
        startTime?: Date | undefined;
        endTime?: Date | undefined;
        customerWage?: number;
        expenseTravelTime?: number;
        drivingFlat?: number;
        manufactDetailsTrans: boolean;
        modified: boolean;
        serviceComplete: number;
        additionalWork: string;
        sA_Memo: string;
        sA_Memo_Add: string;
        sa_ManufactDetailsTrans: boolean;
        notes: string;
        rowID: string;
        fK_AutoCostCenter?: number;
        fK_EmpWorkPlanCategoryID?: number;
        transmitted: boolean;
        createdInVinavon: boolean;
        projectLeader?: string;
    }

    export interface SA_Adress {
        adressID: string;
        mandator: string;
        lastName: string;
        firstName: string;
        street1: string;
        zip: string;
        city: string;
        phone01: string;
        mobile: string;
        email: string;
        parentAdress: string;
        phone02: string;
        mobile2: string;
        email2: string;
    }

    export interface SA_BaseDetail {
        adressID: string;
        name: string;
        adresse: string;
        phone1: string;
        phone2: string;
        mobile1: string;
        mobile2: string;
        mail1: string;
        mail2: string;
    }

    export interface SA_KundeDetail extends SA_BaseDetail {
    }

    export interface SA_KundeKontaktDetail extends SA_BaseDetail {
    }

    export interface SA_RechnungsAdresseDetail extends SA_BaseDetail {
    }

    export interface SA_RechnungsAdresseKontaktDetail extends SA_BaseDetail {
    }

    export interface SA_ArchitektAdresseDetail extends SA_BaseDetail {
    }

    export interface SA_ArchitektAdresseKontaktDetail extends SA_BaseDetail {
    }

    export interface SA_LieferantAdresseDetail extends SA_BaseDetail {
    }

    export interface SA_LieferantAdresseKontaktDetail extends SA_BaseDetail {
    }

    export const EmptySA_KundeDetail = (): SA_KundeDetail => ({
        adressID: '',
        name: '',
        adresse: '',
        phone1: '',
        phone2: '',
        mobile1: '',
        mobile2: '',
        mail1: '',
        mail2: ''
    });

    export const EmptySA_Adress = (): SA_Adress => ({
        adressID: '',
        mandator: '100',
        lastName: '',
        firstName: '',
        street1: '',
        zip: '',
        city: '',
        phone01: '',
        mobile: '',
        email: '',
        parentAdress: '',
        phone02: '',
        mobile2: '',
        email2: ''
    });

    export interface SA_ObjectAdress {
        id: string;
        fK_AdressID: string;
        fK_ObjectID: string;
        fK_ContactID: string;
        fK_AddressTypeNumber?: number;
    }

    export interface SA_Document {
        documentID: string;
        mandator: string;
        fileName: string;
        description: string;
        objectNumber: string;
        createdBy: string;
        createdDate: Date;
        modifiedBy: string;
        modifiedDate?: Date;
        sA_TransDocType: number;
        adressID: string;
        contactID: string;
        adressType?: number;
        sequenceNumber?: number;
        calcSequenceNumber?: number;
        objectID: string;
        uploadRequired: boolean;
        fileModifiedDate?: Date;
        fileState: SA_FileStates;
    }

    export enum SA_FileStates {
        NON_EXISTENT = 0,
        FILE = 1,
        ARCHIVED = 3,
    }

    export interface SA_DocumentAssignment {
        documentID: string;
        employeeID: number;
        fK_ServiceID: string;
    }

    export interface SA_ServicePos {
        servicePosID: string;
        fK_ObjectID: string;
        fK_EmployeeNo: number;
        fK_ServiceID: string;
        deleted: boolean;
        uploaded: boolean;
        entryDate: Date;
        fK_ProductNo: string;
        shortText: string;
        unit: string;
        mandator: string;
        transferred: boolean;
        fK_CostCenterID?: number;
        productType?: number;
        fK_RowID?: string;
        amount?: number;
        saleprice?: number;
        goodWill?: number;
        imported?: number;
        charged?: number;
        length?: number;
        width?: number;
        thickness?: number;
        weightPerUnit?: number;
        productCode?: number;
        totalAmount?: number;
        createdByWL?: number;
        expenseServicePosID?: string;
        deletedInWL?: boolean;
    }

    export interface SA_ServicePosResult {
        servicePosID: string;
        fK_EmployeeNo: number;
        hasError: boolean;
        error: string;
    }

    export interface SA_TimeControlEntry {
        rowID: string;
        mandantID: string;
        servicePosID?: string;
        fk_ObjectID: string;
        fk_EmployeeID: number;
        fk_ServiceID?: string;
        fk_CostCenter?: number;
        description: string;
        expenseID?: number;
        entryDate: Date;
        originalStartTime?: Date;
        originalEndTime?: Date;
        originalTimeAmount: number;
        transfered: number;
        objectNumber: string;
        expenseAmount?: number;
        expenseRate?: number;
        note?: string;
        workplace?: string;
        deleted: boolean;
        uploaded: boolean;
    }

    export interface SA_TimeControlEntryResult {
        servicePosID: string;
        rowID: string;
        hasError: boolean;
        error: string;
    }

    /* Neue Schnittellen von TH*/
    export interface SA_DefaultObjekt {
        objectNumber: string;
        objectID: string;
        objDescription: string;
        note4: string;
    }

    export interface SA_DataForAppointment {
        sA_Termin?: SA_Objekt;
        sA_Anwender?: BenutzerModels.Anwender;
        sA_TimeEntry?: SA_TimeEntry;
        isFinished?: boolean;
    }

    export interface SA_DataTimeMutation {
        sA_Termin?: TimeMutationAppointmentData;
        sA_Anwender?: BenutzerModels.Anwender;
        sA_TimeEntry?: SA_TimeEntry;
        isFinished?: boolean;
    }

    export interface TimeMutationAppointmentData {
        serviceID?: string;
        objectID: string;
        startTime?: Date | null;
        objectNumber: string;
        objDescription?: string;
        description?: string;
    }

    export interface Appointment {
        Id: string;
        StartTime: Date | undefined;
        EndTime: Date | undefined;
    }

    export interface Assignment {
        employeeID: number;
        mandator: string;
        rowID: string;
        serviceID: string;
        objectID: string;
        day: Date | undefined;
        startTime: Date | undefined;
        endTime: Date | undefined;
    }

    export interface TimeRecordingItem extends Assignment {
        costCenterID: number;
        recordingState: RecordingState; /* 1: no recording | 2: in recording | 3: in break */
        onlyTime: string;
        workPlace: string;
    }

    export enum RecordingState {
        NoRecording = 1,
        InRecording = 2,
        InBreak = 3
    }

    export interface SearchFieldResponseItem {
        objectID: string;
        serviceID: string;
        beschreibung: string;
    }

    /* Dieses Interface wird für den Datenaustausch zum Webserver verwendet und die Speicherung in der indexedDB */
    export interface SA_TimeEntry {
        objectID: string;
        servicePosID: string;
        employeeIDS: number[];
        serviceID?: string;
        costCenterID: number;
        workPlace?: string;
        activityDescription: string;
        startDate?: Date;
        endDate?: Date;
        duration: number;
        goodWill?: boolean;
        nightShift?: boolean;
        expenseID?: number;
        expenseAmount?: number;
        expensePrice?: number;
        expenseUnit?: string;
        expenseToCharge?: boolean;
        note?: string;
        deleted: boolean;
        uploadedToServicePos: boolean;
        uploadedToTimeControlEntries: boolean;
    }

    /* Dieses Interface wird für die Anzeige der Daten in der App verwendet */
    export interface SA_ZeitZeile {
        servicePosID: string;
        serviceID?: string;
        datum: Date;
        datumStrEN: string;
        datumStrCH: string;
        mitarbeiter: string;
        auftrag: string;
        zeiten: string;
        startzeit: string;
        endzeit: string;
        zeitMenge: number;
        arbeitsbezeichnung: string;
        spesenArt: string;
        spesenMenge: string;
        spesenBetrag: string;
        arbeitsort: string;
        notizen: string;
        kulanz: boolean;
        uploaded: boolean;
    }

    export interface SA_AuftragZeile {
        serviceID: string;
        datum: Date;
        auftrag: string;
        bezeichnung: string;
        kunde: string;
        anzDokumente: number;
        abgeschlossen: boolean;
        uploadNoetig: boolean;
        uebermittelt: boolean;
    }

    /* Beginn der Artikel-Positionen */

    export interface SA_DataForArticleMutation {
        sA_Termin?: SA_Objekt;
        sA_Anwender?: BenutzerModels.Anwender;
        produkt?: Produkt; // ausgewähltes Produkt aus Artikelstamm
        editProdukt?: SA_ProductEntry; // bestehendes, erfasstes Produkt bearbeiten
    }

    export interface SA_PositionZeile {
        servicePosID: string;
        serviceID: string;
        datum: Date;
        mitarbeiter: string;
        artikelnummer: string;
        bezeichnung: string;
        anzahl: string;
        einheit: string;
        menge: number;
        laengeBreiteDicke: string;
        preisProEinheit: string;
        preisTotal: string;
        preisTotalNum: number;
        spesen: boolean;
        kulanz: boolean;
    }

    export interface SA_ProductEntry {
        rowID: string;
        servicePosID: string;
        serviceID: string;
        ausArtikelStamm: boolean;
        datum: Date;
        mitarbeiter: BenutzerModels.Anwender;
        artikelnummer: string;
        bezeichnung: string;
        anzahl: number;
        einheit: string;
        preisProEinheit: number;
        preisTotal: number;
        laenge: number;
        breite: number;
        dicke: number;
        menge: number;
        mengeTotal: number;
        kulanz: boolean;
        spesen: boolean;
        deleted: boolean;
        uploaded: boolean;
        createdByWL: boolean;
        modifiedInMobile?: boolean;
    }


    export interface SA_RapportZeile {
        servicePosID: string;
        datum: Date;
        mitarbeiter: string;
        artikel: string;
        bezeichnung: string;
        menge: number;
        einheit: string;
        preis: string;
        preisTotal: string;
        kulanz: boolean;
        spesen: boolean;
    }

    /* Termin-Details */
    export interface SA_AppointmentDetails {
        rowID: string;
        serviceID: string;
        datum: Date;
        startzeit: string;
        endzeit: string;
        dateOrTimeModified: boolean;
        note: string;
        additionalWork: string;
        sa_Memo_Add: string;
    }

    /* PDF-Dokument */

    export interface SA_PDFRapport {
        invoice?: Invoice;
        positions: GlobalModels.Dictionary<any>;
        type: string;
    }

    export interface SA_BaseFile {
        documentID: string;
        description: string;
        createdBy: string;
        createdDate: Date;
        objectID: string;
        fileName: string;
        binary: Blob;
        uploaded: boolean;
        lastModified?: Date;
    }

    export interface SA_RapportFile extends SA_BaseFile {
        serviceID: string;
    }

    export interface SA_BildFile extends SA_BaseFile {
        serviceID: string;
    }

    export interface SA_ChecklistFile extends SA_BaseFile {
        serviceID: string;
    }

    export interface DokumentDBFile extends SA_BaseFile {

    }

    export interface SA_ChecklistUploadElement {
        documentID: string;
        objectID: string;
        fileName: string;
        binary: Blob;
    }

    /*
    export interface jsPDFWithPlugin extends jsPDF.jsPDF {
      autoTable : (options: UserOptions) => jsPDF.jsPDF;
    }
    */

    export interface Invoice {
        template: any;
        doc: jsPDF;
        pdf: any;
        logo: any;
        completed: boolean;
        columns: any[];
        rows: any[];
        mandantAdr: any;
        pointer: number;
        output: any;
        name: string;
        address: any;
        MiscTablePos: any;
        data: any[];
        reset: boolean;
        relativepageadded: boolean;
        footerLogoPath: string;
        logoFooter: string;
        printPositionsTable: boolean;
    }

    export interface SA_InvoiceItem {
        ItemHeader: string;
        ItemContent: string;
        ItemX: string;
        ItemY: string;
        ItemWidth: number;
        ItemHeight: number;
        ItemBol: boolean;
        style: string[];
        Position: string;
    }

    export interface SA_LogoFile {
        responseType: string;
        binaryData: string[];
    }

    export interface SA_TimeControlDay {
        datum: string;
        closed: boolean;
        employeeID: number;
        mandator: string;
    }

    /* Dokumente */

    export interface TerminDokumentListElement {
        id: string;
        creator: string;
        // art: number,
        documentName: string;
        description: string;
        datum: Date;
        imageFile: string;
        firstName?: string;
        lastName?: string;
        ansprechVorname?: string;
        ansprechName?: string;
        dokumentTyp: DokumentModels.DokumentTyp;
        documentQuelle: DokumentModels.DokumentSource;
        lastModified?: Date;
    }

    /* Bilder */

    export interface TerminBildListElement {
        id: string;
        creator: string;
        documentName: string;
        description: string;
        datum: Date;
        imageFile: string;
        firstName?: string;
        lastName?: string;
        ansprechVorname?: string;
        ansprechName?: string;
        dokumentQuelle: DokumentModels.DokumentSource;
        objectID?: string;
        uploaded: boolean;
        uploader: number;
        formattedDate: string;
    }

    export interface ImageSliderElement {
        image: string;
        thumbImage: string;
        alt: string;
        title: string;
    }

    export interface CheckListeTemplate {
        mandatorID: string;
        pdfFileTemplate: Blob;
    }

    export interface MailTemplate {
        empfaenger: string;
        betreff: string;
        nachricht: string;
    }

}
